if(!customElements.get('articles-grid')) {
  class ArticlesGrid extends HTMLElement {
    static observedAttributes = [
      "page-current",
      "page-total",
      "page-next"
    ];

    constructor() {
      super();

      this.elFeed = this.querySelector('[data-feed]');
      this.elObserver = this.querySelector('[data-observer]');

      this.observer = this.elObserver ? new IntersectionObserver(this.paginateArticles.bind(this)) : null;
      this.observer.observe(this.elObserver);
    }

    attributeChangedCallback() {
      this.pageCurrent = Number(this.getAttribute('page-current'));
      this.pageTotal = Number(this.getAttribute('page-total'));
      this.pageNext = this.getAttribute('page-next');
    }

    paginateArticles([entry], observer) {
      if (entry.isIntersecting && this.pageCurrent < this.pageTotal) {
        this.elFeed.setAttribute('aria-busy', true);
        this.appendArticles(this.pageNext, true);
      }
    }

    appendArticles(url) {
      this.loadArticles(url)
        .then(elGrid => {
          const elNewFeed = elGrid.querySelector('[data-feed]');
          const elNewArticles = elNewFeed.querySelectorAll('article');
          
          this.setAttribute('page-current', elGrid.getAttribute('page-current'));
          this.setAttribute('page-total', elGrid.getAttribute('page-total'));
          this.setAttribute('page-next', elGrid.getAttribute('page-next'));

          elNewArticles.forEach(el => this.elFeed.appendChild(el));
          window.initLazyLoad();
        })
    }

    async loadArticles(url) {
      const response = await fetch(url);
      const data = await response.text();

      const html = new DOMParser().parseFromString(data, 'text/html');
      const elGrid = html.querySelector(`#${this.id}`);

      return elGrid;
    }
  }

  customElements.define('articles-grid', ArticlesGrid);
}